var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "play2",
  "use": "play2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"play2\"><polygon points=\"23 7 16 12 23 17 23 7\" /><rect height=\"14\" rx=\"2\" ry=\"2\" width=\"15\" x=\"2\" y=\"5\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id